import { render, staticRenderFns } from "./ExpressProblemTable.vue?vue&type=template&id=a828b2c8&scoped=true"
import script from "./ExpressProblemTable.vue?vue&type=script&lang=js"
export * from "./ExpressProblemTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a828b2c8",
  null
  
)

export default component.exports